module.exports = __webpack_public_path__ + "img/paid-bosch.36d21358.png";